import React from 'react';
import Table from '../Table';
import { formatUnixTime } from '../../../utils';

const ErrorLogTable = ({ logs }) => {
  const headers = ['Date/Time', 'Error Code', 'Description'];

  // Check if there are any logs
  if (!logs || logs.length === 0) {
    return <p className="text-error font-bold">No logs</p>; // Display message when logs are empty
  }

  const rows = logs.map((log) => [
    formatUnixTime(log.time),
    log.code || 'N/A', // Default to 'N/A' if code doesn't exist
    log.description || 'No description available', // Handle missing description
  ]);

  return <Table headers={headers} rows={rows} />;
};

export default ErrorLogTable;
